export const DEFAULT_CONFIG = {
    generator: null,
    value: 'circle',
    range: ['circle', 'diamond', 'star', 'cross', 'square', 'wye', 'triangle']
};
